import { useTranslation } from 'next-i18next'
import { Box, Heading, Text } from '@machobear/design-system'

import { AlertButtonList } from '@/features/Listings/buttons'

const EmptyState = ({ isCampus = false }) => {
  const { t } = useTranslation()

  const campusDescriptionText = t('No listings found for this campus.')
  const regularDescriptionText = t(
    'filters:b.listings.view.map_no_results.text',
    'Create a listing alert to be the first to know when new listings become available.'
  )
  const descriptionText = isCampus
    ? campusDescriptionText
    : regularDescriptionText

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      marginY="xxxlarge"
      paddingY="gutter"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="medium"
        paddingBottom="xxxlarge"
        style={{ maxWidth: '324px' }}
        textAlign="center"
        background="white"
      >
        <Heading level="4" component="h2" weight="weak">
          {t(
            'filters:b.listings.view.map_no_results.title',
            'Good Listings Go Fast!'
          )}
        </Heading>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="large"
        >
          <Text size="standard" align="center">
            {descriptionText}
          </Text>
          {!isCampus && <AlertButtonList primary hideOnMobile={false} />}
        </Box>
      </Box>
    </Box>
  )
}

export default EmptyState
